import React from 'react'
import { Link, graphql } from 'gatsby'
import { Trans } from 'gatsby-plugin-react-i18next'
import { StaticImage } from 'gatsby-plugin-image'
import { Seo } from '../components/SEO'

import ProductsHero from '../components/ProductsHero'
import TilesSwiper2 from '../components/TilesSwiper2'
import SectionTechnology from '../components/SectionTechnology'
import SelectedProducts from '../components/SelectedProducts'
import SectionBackground from '../components/SectionBackground'
import VumographyShowcase from '../components/VumographyShowcase'
import SectionBigTile from '../components/SectionBigTile'

import MHeroVideo from '../assets/video/mobile/mobile_KV03.mp4'
import THeroVideo from '../assets/video/tablet/tablet_KV03.mp4'
import DHeroVideo from '../assets/video/desktop/desktop_KV03.mp4'

import Icon1 from '../assets/svg/Products-icon1.inline.svg'
import Icon2 from '../assets/svg/Products-icon2.inline.svg'
import Icon3 from '../assets/svg/Products-icon3.inline.svg'
import Icon4 from '../assets/svg/Products-icon4.inline.svg'
import Icon5 from '../assets/svg/Products-icon5.inline.svg'
import Icon6 from '../assets/svg/Products-icon6.inline.svg'
import Icon7 from '../assets/svg/Products-icon7.inline.svg'
import Icon8 from '../assets/svg/Products-icon8.inline.svg'
import Icon9 from '../assets/svg/Products-icon9.inline.svg'
import Icon10 from '../assets/svg/Products-icon10.inline.svg'
import Icon11 from '../assets/svg/Products-icon11.inline.svg'
import Icon12 from '../assets/svg/Products-icon12.inline.svg'
import Icon13 from '../assets/svg/Products-icon13.inline.svg'
import Icon14 from '../assets/svg/Products-icon14.inline.svg'
import Icon15 from '../assets/svg/Products-icon15.inline.svg'

import BG1 from '../assets/imgs/Vumography/Vumography-BG1.webp'
import BG2 from '../assets/imgs/Vumography/Vumography-BG2.webp'
import BG3 from '../assets/imgs/Vumography/Vumography-BG3.webp'
import BG4 from '../assets/imgs/Vumography/Vumography-BG4.webp'
import BG5 from '../assets/imgs/Vumography/Vumography-BG5.webp'
import BG6 from '../assets/imgs/Vumography/Vumography-BG6.webp'

const BGObject = [
  {
    name: 'BG1',
    img: BG1,
    alt: 'Blue BMW vehicle with generic background',
  },
  {
    name: 'BG2',
    img: BG2,
    alt: 'Blue BMW vehicle on spinning platform',
  },
  {
    name: 'BG3',
    img: BG3,
    alt: 'Vehicle generated with background containing concrete floor and fog',
  },
  {
    name: 'BG4',
    img: BG4,
    alt: 'Blue BMW vehicle with blurred background',
  },
  {
    name: 'BG5',
    img: BG5,
    alt: 'Vehicle generated on background containing concrete floor and white wall',
  },
  {
    name: 'BG6',
    img: BG6,
    alt: 'Blue BMW vehicle with grey background',
  },
]

const SlideTiles1 = [
  {
    content: <Trans>SlideTilesContent1_1</Trans>,
    icon: <Icon2 />,
  },
  {
    content: <Trans>SlideTilesContent1_2</Trans>,
    icon: <Icon4 />,
  },
  {
    content: <Trans>SlideTilesContent1_3</Trans>,
    icon: <Icon5 />,
  },
  {
    content: <Trans>SlideTilesContent1_4</Trans>,
    icon: <Icon6 />,
  },
  {
    content: <Trans>SlideTilesContent1_5</Trans>,
    icon: <Icon7 />,
  },
  {
    content: <Trans>SlideTilesContent1_6</Trans>,
    icon: <Icon3 />,
  },
  {
    content: <Trans>SlideTilesContent1_7</Trans>,
    icon: <Icon8 />,
  },
]

const SlideTiles2 = [
  {
    content: <Trans>SlideTilesContent2_1</Trans>,
    icon: <Icon9 />,
  },
  {
    content: <Trans>SlideTilesContent2_2</Trans>,
    icon: <Icon10 />,
  },
  {
    content: <Trans>SlideTilesContent2_3</Trans>,
    icon: <Icon11 />,
  },
  {
    content: <Trans>SlideTilesContent2_4</Trans>,
    icon: <Icon12 />,
  },
  {
    content: <Trans>SlideTilesContent2_5</Trans>,
    icon: <Icon13 />,
  },
]

const vumography = () => {
  return (
    <>
      <ProductsHero
        id='vumographyHero'
        whereToScroll='vumographyshowcase'
        title={<Trans>ProductsHeroTitle</Trans>}
        heading={<Trans>ProductsHeroHeading</Trans>}
        description={<Trans>ProductsHeroDescription</Trans>}
        MHeroVideo={MHeroVideo}
        THeroVideo={THeroVideo}
        DHeroVideo={DHeroVideo}
        scrollBtnStyles='lg:block'
      />

      <VumographyShowcase
        exterior={<Trans>VumographyShowCaseExterior</Trans>}

        heading1={<Trans>VumographyShowcaseHeading1</Trans>}
        description1={<Trans>VumographyShowcaseDescription1</Trans>}
        heading2={<Trans>VumographyShowcaseHeading2</Trans>}
        description2={<Trans>VumographyShowcaseDescription2</Trans>}
        textAboveBtn={<Trans>VumographyShowCaseTextAboveBtn</Trans>}
        btnText={<Trans>VumographyShowCaseBtnText</Trans>}
        id='vumographyshowcase'
      />

      <div
        id='vumography'
        className='xl:max-w-[1920px] xl:mx-auto lg:flex-row flex flex-col lg:shrink-0'
      >
        <div className='container lg:basis-1/2 lg:order-2 lg:py-[70px] lg:pl-[90px] lg:gap-[75px] md:gap-[85px] md:py-[30px] flex justify-center gap-[10px] bg-gray-100 pt-[40px] pb-[25px]'>
          <StaticImage
            src='../assets/imgs/vumography_1x2.png'
            alt='Vumography try it'
            placeholder='blurred'
            height={506}
            className=' self-start'
            data-aos='fade-up'
            data-aos-duration='500'
            data-aos-easing='ease-in-out'
            data-aos-delay='150'
          />
          <StaticImage
            src='../assets/imgs/vumography_2x2.png'
            alt='Vumography try it results'
            placeholder='blurred'
            height={506}
            className='md:mt-[125px] mt-[100px] self-start'
            data-aos='fade-up'
            data-aos-duration='500'
            data-aos-easing='ease-in-out'
            data-aos-delay='150'
          />
        </div>
        <div className='container bg-white lg:basis-1/2 lg:pt-[140px] md:pt-[50px] md:pb-[65px] pt-[40px] pb-[50px] text-black-100'>
          <h2
            className='md:text-4xl text-3xl mb-[24px]'
            data-aos='fade-up'
            data-aos-duration='500'
            data-aos-easing='ease-in-out'
          >
            <Trans>VumographyListHeading</Trans>
          </h2>
          <p
            className='text-[18px]'
            data-aos='fade-up'
            data-aos-duration='500'
            data-aos-easing='ease-in-out'
          >
            <Trans>VumographyListDescription1</Trans>
          </p>
          <ul className='my-[25px] custom-counter text-[18px]'>
            <li
              data-aos='fade-up'
              data-aos-duration='500'
              data-aos-easing='ease-in-out'
            >
              <Trans>VumographyListItem1</Trans>
            </li>
            <li
              data-aos='fade-up'
              data-aos-duration='500'
              data-aos-easing='ease-in-out'
              data-aos-delay='200'
            >
              <Trans>VumographyListItem2</Trans>
            </li>
            <li
              data-aos='fade-up'
              data-aos-duration='500'
              data-aos-easing='ease-in-out'
              data-aos-delay='400'
            >
              <Trans>VumographyListItem3</Trans>
            </li>
          </ul>
          <p
            className='text-[18px]'
            data-aos='fade-up'
            data-aos-duration='500'
            data-aos-easing='ease-in-out'
            data-aos-delay='600'
          >
            <Trans>VumographyListDescription2</Trans>
          </p>
        </div>
      </div>

      <SectionBackground
        BGObject={BGObject}
        heading={<Trans>SectionBackgroundHeading</Trans>}
        description={<Trans>SectionBackgroundDescription</Trans>}
      />
      {/* GridStyles prop has as default "hidden md:grid" */}
      {/* SlideTiles means array like on top in this file */}
      <div className='pt-[75px] lg:block hidden bg-gray-100'></div>
      <TilesSwiper2
        SlideTiles={SlideTiles1}
        TileStyle='min-h-[255px] justify-center'
        GridStyles='lg:grid-cols-4 lg:gap-[17px] grid-cols-2 auto-rows-fr gap-[15px]'
        heading='Features'
      />
      <TilesSwiper2
        SlideTiles={SlideTiles2}
        GridStyles='lg:grid-cols-5 lg:gap-[17px] grid-cols-3 auto-rows-fr gap-[15px]'
        heading='Benefits'
      />

      <SectionBigTile
        heading={<Trans>SectionBigTileHeading</Trans>}
        content={<Trans>SectionBigTileContent</Trans>}
        icon1={<Icon14 />}
        icon2={<Icon15 />}
        icon3={<Icon1 />}
      />

      <SectionTechnology
        id='sectionTechnology'
        heading={<Trans>SectionTechnologyHeading</Trans>}
        content={<Trans>SectionTechnologyContent</Trans>}
        content_2={<Trans>SectionTechnologyContent_2</Trans>}
        content_3={<Trans>SectionTechnologyContent_3</Trans>}
      />



      <SelectedProducts
        title={<Trans>SelectedProductsTitle</Trans>}
        end={<Trans>SelectedProductsEnd</Trans>}
        slug='/vumography'
      />
    </>
  )
}

export const Head = () => (
  <Seo
    title='Vumography – Get instantly replaced backgrounds | Vumo.ai'
    description='Get instantly replaced backgrounds. Create a digital showroom for your inventory. Make your online listing stand out and surpass your competitors.'
  />
)

export const query = graphql`
  query ($language: String!) {
    locales: allLocale(
      filter: { language: { eq: $language }, ns: { eq: "vumography" } }
    ) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`

export default vumography
